var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6348 7.40625H5.63477",
    stroke: "#AE2121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6348 13.4062V21.4062",
    stroke: "#AE2121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6348 13.4062V21.4062",
    stroke: "#AE2121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6348 7.40625V26.4062C25.6348 26.6715 25.5294 26.9258 25.3419 27.1134C25.1543 27.3009 24.9 27.4062 24.6348 27.4062H8.63477C8.36955 27.4062 8.1152 27.3009 7.92766 27.1134C7.74012 26.9258 7.63477 26.6715 7.63477 26.4062V7.40625",
    stroke: "#AE2121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6348 7.40625V5.40625C21.6348 4.87582 21.4241 4.36711 21.049 3.99204C20.6739 3.61696 20.1652 3.40625 19.6348 3.40625H13.6348C13.1043 3.40625 12.5956 3.61696 12.2206 3.99204C11.8455 4.36711 11.6348 4.87582 11.6348 5.40625V7.40625",
    stroke: "#AE2121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a56311fd92cd0d8e01c05ee6dd78f780.svg";
export { ForwardRef as ReactComponent };